import React, { useEffect } from 'react';
import { ICreateProfile, IProfile, IUpdateProfile } from '../../@types';
import { updateProfile } from '../../backend-services';
import BankAccountStep from './BankAccount';
import BrandIdentity from './BrandIdentity';
import BusinessInfoStep from './BusinessInfoStep';
import BusinessTypeStep from './BusinessTypeStep';


const handleUpdateProfile = async (profile: IUpdateProfile ) => {

  try {
     
      const data = await updateProfile({
          firstName: profile.firstName,
          lastName: profile.lastName,
          phone: profile.phone,
          industry: profile.industry,
          address: profile.address,
          state: profile.state,
          city: profile.city,
      businessType:profile.businessType,
          businessSize:profile.businessSize,
          brandColor:profile.brandColor,
          brandLogo:profile.brandLogo,

      });
  
    } catch (e) {
     console.log(e)
    }
  };
interface StepContentProps {
  activeStep: number;
  setActiveStep: (step: number) => void;
}

const stepInformation = [
  'Business Type',
  'Business Info',
  'Brand Identity',
  'Bank Account',
];

const StepContent: React.FC<StepContentProps> = ({ activeStep, setActiveStep }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeStep]);

  const renderStep = () => {
    switch (activeStep) {
      case 0:
        return <BusinessTypeStep setActiveStep={setActiveStep} handleUpdateProfile={handleUpdateProfile} />;
      case 1:
        return <BusinessInfoStep setActiveStep={setActiveStep} handleUpdateProfile={handleUpdateProfile} />;
      case 2:
        return <BrandIdentity setActiveStep={setActiveStep} handleUpdateProfile={handleUpdateProfile} />;
      case 3:
        return <BankAccountStep setActiveStep={setActiveStep} />;
      default:
        return null;
    }
  };


  return (
    <div className="w-7/10 p-4">
      {renderStep()}
      <div className="flex justify-center w-full bg-[#F2F9FD] p-4 md:hidden fixed bottom-0">
        {stepInformation.map((step, index) => (
          <div
            key={index}
            style={{
              width: '20px',
              height: '4px',
              backgroundColor: activeStep >= index ? '#044E97' : '#D6DADD',
              margin: '0 5px',
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default StepContent;


